import { render, staticRenderFns } from "./EmployeeCraft.vue?vue&type=template&id=348f8318&"
import script from "./EmployeeCraft.vue?vue&type=script&lang=js&"
export * from "./EmployeeCraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports